<template>
  <div class="container-calendar" id="calendar">
    <div class="btn-triggers">
      <el-button
        v-if="legacy"
        @click="toggleLegacy"
        :type="isLegacy ? 'default' : 'danger'"
        :class="{ 'opacity-60 hover:opacity-100': isLegacy }"
      >
        <svg
          :class="{ 'animate-ping': isLegacy }"
          :width="isLegacy ? '10' : '16'"
          :height="isLegacy ? '10' : '16'"
          viewBox="0 0 0.72 0.72"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M.39.06.123.381Q.108.399.107.405a.02.02 0 0 0 .006.012Q.118.421.142.42H.36L.33.66.597.339Q.613.321.613.315A.02.02 0 0 0 .607.303Q.602.299.578.3H.36z"
            :stroke="isLegacy ? '#666666' : '#FF0000'"
            stroke-width=".05"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span
          class="ml-1 text-xs"
          :class="{ 'text-red-500': !isLegacy, 'text-gray-600': isLegacy }"
          >Turbo Calendar</span
        >
      </el-button>
      <slot v-if="$store.layouts?.calendar?.report_stats">
        <el-popover placement="bottom" title="" width="250" trigger="click">
          <div class="el-cards report-stats">
            <el-card class="dense flat" shadow="never">
              <div slot="header" class="clearfix">
                <span>Report Stats</span>
              </div>
            </el-card>
          </div>
          <el-button slot="reference" class="el-icon-pie-chart" />
        </el-popover>
      </slot>
      <slot v-if="withDrawer">
        <el-button
          v-if="!isBroker"
          @click="drawers.drivers = true"
          class="el-icon-truck"
        />
        <el-button
          v-if="isBroker"
          @click="drawers.carriers = true"
          class="el-icon-truck"
        />
        <el-button
          @click="drawers.settings = true"
          class="el-icon-s-operation"
        />
      </slot>
      <e-fullscreen :selector="'#calendar'" />
    </div>
    <el-drawer
      :visible.sync="drawers.drivers"
      :with-header="false"
      :modal="false"
      size="300px"
    >
      <driver-pane />
    </el-drawer>
    <el-drawer
      :visible.sync="drawers.carriers"
      :with-header="false"
      :modal="false"
      size="300px"
    >
      <carrier-pane />
    </el-drawer>
    <el-drawer
      :visible.sync="drawers.settings"
      :with-header="false"
      :modal="false"
      size="400px"
    >
      <div class="el-cards">
        <el-card class="dense flat" shadow="never">
          <div slot="header" class="clearfix">
            <span>Calendar</span>
          </div>
          <el-button-group style="margin-bottom: 5px">
            <el-button size="mini" @click="currentDay">Today</el-button>
            <el-button size="mini" @click="currentWeek">Current Week</el-button>
            <el-button size="mini" @click="previousWeek"
              >Previous Week</el-button
            >
            <el-button size="mini" @click="nextWeek">Next Week</el-button>
          </el-button-group>
          <el-button-group>
            <el-date-picker
              ref="picker"
              size="mini"
              v-model="startEndDates"
              :editable="false"
              :clearable="false"
              type="daterange"
              format="MM/dd/yy"
              :value-format="'yyyy-MM-dd'"
              range-separator="~"
              start-placeholder="From"
              end-placeholder="To"
              :picker-options="pickerOptions"
              style="width: 305.8px"
            >
            </el-date-picker>
          </el-button-group>
        </el-card>
        <el-card class="dense flat" shadow="never">
          <div slot="header" class="clearfix flex-space">
            <span>Settings</span>
            <a @click="moreSettings = !moreSettings">
              <i class="el-icon-arrow-up bold" v-if="moreSettings" />
              <i class="el-icon-arrow-down bold" v-else />
            </a>
          </div>
          <div>
            <slot v-if="isLegacy">
              <el-checkbox
                v-model="taskDisplay"
                @change="updateSettings({ calendarTaskDisplay: taskDisplay })"
                class="block"
              >
                View Tasks
              </el-checkbox>
              <el-checkbox
                v-model="pickupInstrDisplay"
                @change="
                  updateSettings({
                    calendarPickupInstrDisplay: pickupInstrDisplay,
                  })
                "
                class="block"
              >
                View Pickup Instruction
              </el-checkbox>
              <el-checkbox
                v-model="emptyReturnInstrDisplay"
                @change="
                  updateSettings({
                    calendarEmptyReturnInstrDisplay: emptyReturnInstrDisplay,
                  })
                "
                class="block"
              >
                View Empty Return Instruction
              </el-checkbox>
            </slot>
            <el-checkbox
              v-model="completedOrdersHidden"
              @change="
                updateSettings({
                  calendarCompletedOrdersHidden: completedOrdersHidden,
                })
              "
              class="block"
            >
              Completed Orders Hidden
            </el-checkbox>
            <el-checkbox
              v-model="defaultColorStylesDisabled"
              @change="
                updateSettings({
                  calendarDefaultColorStylesDisabled:
                    defaultColorStylesDisabled,
                })
              "
              class="block"
            >
              Default Color Styles Disabled
            </el-checkbox>

            <label>Operation Display</label>
            <el-radio-group
              v-model="opsDisplay"
              size="mini"
              @change="updateSettings({ calendarOpsDisplay: opsDisplay })"
            >
              <el-radio label="default">Default</el-radio>
              <el-radio label="expand">Expand</el-radio>
              <el-radio label="collapse">Collapse</el-radio>
            </el-radio-group>
            <label>Orders Display</label>
            <el-radio-group
              v-model="orderDisplay"
              size="mini"
              @change="updateSettings({ calendarOrderDisplay: orderDisplay })"
            >
              <el-radio label="horizontal">Horizontal</el-radio>
              <el-radio label="vertical">Vertical</el-radio>
            </el-radio-group>
            <label>Check Markers</label>
            <el-button
              size="mini"
              class="micro"
              type="danger"
              plain
              @click.stop="resetCheckMarkers('o')"
              >Clear Order Markers</el-button
            >
            <el-button
              size="mini"
              class="micro"
              type="danger"
              plain
              @click.stop="resetCheckMarkers('r')"
              >Clear Route Markers</el-button
            >
          </div>
          <slot v-if="moreSettings">
            <label>Sort Columns: drag&drop</label>
            <div class="sort-columns">
              <div v-for="(options, target) in columnOptions" :key="target">
                <div class="box">
                  <div class="box-title flex-space">
                    <div v-if="target == 'calimdl'">Import/Export</div>
                    <div v-if="target == 'calltl'">TL</div>
                    <a @click="resetColumns(target)">reset</a>
                  </div>
                  <div class="box-content">
                    <draggable
                      v-model="columnOptions[target]"
                      class="stripe draggable-columns"
                      draggable=".stripe-item"
                      ghost-class="ghost"
                      :move="checkMove"
                      @change="moveColumn(target)"
                    >
                      <div
                        v-for="column in options"
                        :key="column.name"
                        class="stripe-item"
                      >
                        <el-checkbox
                          v-if="!column.disabled"
                          v-model="column.visible"
                          :disabled="column.name == 'ID'"
                          @change="toggleColumn($event, target, column.name)"
                          >{{ column.name }}</el-checkbox
                        >
                      </div>
                    </draggable>
                  </div>
                </div>
              </div>
            </div>
          </slot>
        </el-card>
      </div>
    </el-drawer>
    <el-tabs
      class="dense calendar"
      type="border-card"
      v-model="activeTab"
      @tab-remove="removeTab"
    >
      <el-tab-pane key="previous" name="previous" disabled>
        <a slot="label" @click="previousDay">
          <i class="el-icon-d-arrow-left" />
        </a>
      </el-tab-pane>
      <el-tab-pane
        v-for="date in dateRanges"
        :key="date"
        :name="date"
        :closable="tabClosable(date)"
      >
        <span slot="label" :data-date="date">
          <span
            class="hidden animate-ping absolute h-full w-full rounded bg-sky-400 opacity-75"
          />
          <svg
            class="-mt-1"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.28033 2.46967C7.13968 2.32902 6.94891 2.25 6.75 2.25C6.55109 2.25 6.36032 2.32902 6.21967 2.46967C6.07902 2.61032 6 2.80109 6 3V4.5H5.25C4.45435 4.5 3.69129 4.81607 3.12868 5.37868C2.56607 5.94129 2.25 6.70435 2.25 7.5V18.75C2.25 19.5456 2.56607 20.3087 3.12868 20.8713C3.69129 21.4339 4.45435 21.75 5.25 21.75H18.75C19.5456 21.75 20.3087 21.4339 20.8713 20.8713C21.4339 20.3087 21.75 19.5456 21.75 18.75V7.5C21.75 6.70435 21.4339 5.94129 20.8713 5.37868C20.3087 4.81607 19.5456 4.5 18.75 4.5H18V3C18 2.80109 17.921 2.61032 17.7803 2.46967C17.6397 2.32902 17.4489 2.25 17.25 2.25C17.0511 2.25 16.8603 2.32902 16.7197 2.46967C16.579 2.61032 16.5 2.80109 16.5 3V4.5H7.5V3C7.5 2.80109 7.42098 2.61032 7.28033 2.46967ZM19.8107 8.18934C20.092 8.47064 20.25 8.85218 20.25 9.25V18.75C20.25 19.1478 20.092 19.5294 19.8107 19.8107C19.5294 20.092 19.1478 20.25 18.75 20.25H5.25C4.85218 20.25 4.47064 20.092 4.18934 19.8107C3.90804 19.5294 3.75 19.1478 3.75 18.75V9.25C3.75 8.85218 3.90804 8.47064 4.18934 8.18934C4.47064 7.90804 4.85218 7.75 5.25 7.75H18.75C19.1478 7.75 19.5294 7.90804 19.8107 8.18934ZM19.1758 10.8965C19.1758 11.5868 18.6161 12.1465 17.9258 12.1465C17.6834 12.1465 17.4572 12.0775 17.2656 11.9581C17.2416 11.9462 17.2182 11.9322 17.1957 11.9161C17.1734 11.9 17.1528 11.8825 17.1339 11.8637C16.8542 11.6345 16.6758 11.2863 16.6758 10.8965C16.6758 10.2061 17.2354 9.64648 17.9258 9.64648C18.6161 9.64648 19.1758 10.2061 19.1758 10.8965ZM16.6882 12.6233C16.9125 12.7843 16.9638 13.0967 16.8028 13.321L15.7122 14.8407C15.5511 15.065 15.2388 15.1164 15.0144 14.9554C14.7901 14.7944 14.7387 14.482 14.8997 14.2576L15.9904 12.738C16.1514 12.5136 16.4638 12.4623 16.6882 12.6233ZM13.2246 15.3776L10.9188 13.7044C10.9438 13.6059 10.957 13.5027 10.957 13.3965C10.957 12.7061 10.3974 12.1465 9.70703 12.1465C9.01667 12.1465 8.45703 12.7061 8.45703 13.3965C8.45703 13.5555 8.48673 13.7076 8.5409 13.8476L6.9793 15.2397C6.79748 15.1365 6.58726 15.0776 6.36328 15.0776C5.67293 15.0776 5.11328 15.6373 5.11328 16.3276C5.11328 17.018 5.67293 17.5776 6.36328 17.5776C7.05364 17.5776 7.61328 17.018 7.61328 16.3276C7.61328 16.2298 7.60204 16.1346 7.58077 16.0432L9.24595 14.5587C9.38862 14.6153 9.54419 14.6465 9.70703 14.6465C9.92362 14.6465 10.1273 14.5914 10.305 14.4945L12.6134 16.1696C12.5891 16.267 12.5762 16.3688 12.5762 16.4736C12.5762 17.164 13.1358 17.7236 13.8262 17.7236C14.5165 17.7236 15.0762 17.164 15.0762 16.4736C15.0762 15.7833 14.5165 15.2236 13.8262 15.2236C13.6081 15.2236 13.4031 15.2795 13.2246 15.3776Z"
              fill="currentColor"
            />
          </svg>
          {{ formatDate(date) }}
          <el-badge type="primary" :value="counts[date]" />
        </span>
        <ContainerCalendarWidget
          :key="widgetKey(date)"
          :mark="date"
          :hubId="hubId"
          :receivedData="receivedData"
          :isActive="activeTab === date"
          @updateCount="updateCount"
        />
      </el-tab-pane>
      <el-tab-pane key="next" name="next" disabled>
        <a slot="label" @click="nextDay">
          <i class="el-icon-d-arrow-right" />
        </a>
      </el-tab-pane>
      <slot v-if="$store.layouts?.calendar">
        <slot v-if="$store.layouts.calendar.upcoming_loads">
          <el-tab-pane name="upcoming_loads" lazy>
            <span slot="label">
              Upcoming
              <el-badge class="mark" :value="counts['upcoming_loads']" />
            </span>
            <ContainerCalendarWidget
              :key="widgetKey('upcoming_loads')"
              :mark="'upcoming_loads'"
              :hubId="hubId"
              :receivedData="receivedData"
              :isActive="activeTab === 'upcoming_loads'"
              @updateCount="updateCount"
            />
          </el-tab-pane>
        </slot>
        <slot v-if="$store.layouts.calendar.not_scheduled">
          <el-tab-pane name="not_sched" lazy>
            <span slot="label">
              Not Sched.
              <el-badge class="mark" :value="counts['not_sched']" />
            </span>
            <ContainerCalendarWidget
              :key="widgetKey('not_sched')"
              :mark="'not_sched'"
              :hubId="hubId"
              :receivedData="receivedData"
              :isActive="activeTab === 'not_sched'"
              @updateCount="updateCount"
            />
          </el-tab-pane>
        </slot>
        <slot v-if="$store.layouts.calendar.past_due_ops">
          <el-tab-pane name="past_due_ops" lazy>
            <span slot="label">
              Past Due Stops
              <el-badge class="mark" :value="counts['past_due_ops']" />
            </span>
            <ContainerPastDueOps :hubId="hubId" />
          </el-tab-pane>
        </slot>
        <slot v-if="$store.layouts.calendar.pre_alert">
          <el-tab-pane name="pre_alert" lazy>
            <span slot="label">
              Pre-Alerts
              <el-badge class="mark" :value="counts['pre_alert']" />
            </span>
            <ContainerPreAlert
              :mark="'pre_alert'"
              :hubId="hubId"
              :offsets="[445, 200]"
              source="calendar"
              @updateCount="updateCount"
            />
          </el-tab-pane>
        </slot>
        <el-tab-pane name="order_status" class="order-status-tab" lazy>
          <span slot="label"> Order Status </span>
          <ContainerOrderStatus />
        </el-tab-pane>
      </slot>
    </el-tabs>
    <chat-popup />
  </div>
</template>
<script>
import { format, parse, addDays, startOfISOWeek } from "date-fns";
import api from "@/default/utils/api";
import ContainerCalendarWidget from "@/default/pages/containers/calendar/widget.vue";
import ContainerPreAlert from "@/default/pages/containers/pre_alert/index.vue";
import ContainerPastDueOps from "@/default/pages/containers/past_due_ops.vue";
import ContainerOrderStatus from "@/default/pages/containers/order_status/index.vue";

export default {
  name: "ContainerCalendar",
  mixins: [api],
  components: {
    ContainerCalendarWidget,
    ContainerPreAlert,
    ContainerPastDueOps,
    ContainerOrderStatus,
  },
  props: {
    legacy: {
      type: Boolean,
      default: false,
    },
    from: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    hubId: {
      type: Number,
      required: true,
    },
    preCounts: {
      type: Object,
      default: () => ({}),
    },
    layout: {
      type: Object,
      default: () => ({}),
    },
    apptOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      drawers: {
        drivers: false,
        carriers: false,
        settings: false,
        reports: false,
      },
      counts: this.preCounts,
      startEndDates: [this.from, this.to],
      activeTab: null,
      columnOptions: {
        calimdl: [],
        calltl: [],
      },
      completedOrdersHidden: false,
      defaultColorStylesDisabled: false,
      taskDisplay: false,
      pickupInstrDisplay: false,
      emptyReturnInstrDisplay: false,
      opsDisplay: "default",
      orderDisplay: "horizontal",
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.curDate = minDate.getTime();
          if (maxDate) {
            this.curDate = "";
          }
        },
        disabledDate: (time) => {
          if (this.curDate) {
            const week = 24 * 3600 * 1000 * 6;
            const minTime = this.curDate - week;
            const maxTime = this.curDate + week;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        },
      },
      receivedData: {},
      moreSettings: true,
      format,
      parse,
      addDays,
      startOfISOWeek,
    };
  },
  mounted() {
    this.stopBack();
    this.initColumnOptions();
    this.initByStorage();
    this.activeTab = this.dateRanges[0];
    this.$actions.setHubId(this.hubId);
    this.$actions.setLayout("calendar", this.layout);
    this.$nextTick(() => {
      this.appendReportStats();
    });
    window.ContainerCalendar = {
      receive: this.receive,
    };
  },
  async created() {
    await this.loadEnvs(this.disableColumns);
  },
  watch: {
    activeTab(nv, ov) {
      if (nv != ov) {
        if (/\d{4}-\d{2}-\d{2}/.test(nv)) {
          this.$actions.setCalDate(nv);
        }
        if (/pre_alert/.test(nv)) {
          setTimeout(() => {
            window.dispatchEvent(new Event("resize"));
          }, 500);
        }
        if (nv == "order_status") {
          setTimeout(() => {
            window.dispatchEvent(new Event("resize"));
          }, 100);
        }
      }
    },
    startEndDates(nv, ov) {
      if (nv != ov) {
        if (!this.dateRanges.includes(this.activeTab)) {
          this.activeTab = this.dateRanges[0];
        }
      }
    },
  },
  computed: {
    isLegacy() {
      if (this.$store.settings.calendarLegacy === undefined) {
        this.$actions.updateSettings({ calendarLegacy: false });
      }
      return this.$store.settings.calendarLegacy;
    },
    widgetKey() {
      return function (mark) {
        return [this.isLegacy ? "legacy" : "turbo", mark].join("-");
      };
    },
    today() {
      return this.format(new Date(), "yyyy-MM-dd");
    },
    dateRanges() {
      const [from, to] = this.startEndDates;
      let dates = [];
      let start = this.parse(from, "yyyy-MM-dd", new Date());
      let end = this.parse(to, "yyyy-MM-dd", new Date());
      while (start <= end) {
        dates.push(this.format(start, "yyyy-MM-dd"));
        start = this.addDays(start, 1);
      }
      return dates;
    },
    internalDates() {
      return [...this.dateRanges].slice(1, -1);
    },
    tabClosable() {
      return function (name) {
        return !this.internalDates.includes(name) && this.dateRanges.length > 1;
      };
    },
    withDrawer() {
      return !/past_due_ops|pre_alert/i.test(this.activeTab);
    },
  },
  methods: {
    toggleLegacy() {
      this.$actions.updateSettings({ calendarLegacy: !this.isLegacy });
      this.initColumnOptions();
    },
    appendReportStats() {
      const div = document.querySelector(".report-stats .el-card__body");
      const links = document.querySelector("#report-links");
      if (div && links) {
        links.classList.remove("hidden");
        div.appendChild(links);
      }
    },
    initColumnOptions() {
      let columns = [
        "ID",
        "Action",
        "Type",
        "Customer",
        "Operations",
        "Route EST",
        "Route Status",
        "Instructions",
        "Street Turn",
        "Accts. Receivable",
        "Accts. Payable",
        "Profit",
        "Warehouse Name",
        "Warehouse City",
        "Warehouse State",
        "Appt. Time",
        "Ssline",
        "Terminals",
        "Depots",
        "Size/Type",
        "Commodity",
        "Priority",
        "Triaxle",
        "HAZ",
        "CONT.#",
        "REF.#",
        "SSLine B/L#",
        "Chassis#",
        "Pickup#",
        "Empty Release#",
        "Term. ETA",
        "Term. LFD",
        "Vendor",
        "Per Diem LFD",
        "Line LFD",
        "Early Receiving Date",
        "Cut Off Date",
        "Notify Ready",
        "Dispatch",
        "Tasks",
      ];

      const excludes = ["Route Status", "Instructions"];
      this.$actions.renameTableColumn("calimdl", "ETA", "Term. ETA");
      this.$actions.renameTableColumn("calimdl", "Last Free Day", "Term. LFD");
      this.$actions.renameTableColumn(
        "calimdl",
        "Per Diem Last Free Day",
        "Per Diem LFD",
      );
      if (this.isLegacy) columns = columns.filter((o) => !excludes.includes(o));
      this.columnOptions.calimdl = this.initTableColumns("calimdl", columns);
      columns = [
        "ID",
        "Action",
        "Customers",
        "Operations",
        "Route EST",
        "Route Status",
        "Instructions",
        "Accts. Receivable",
        "Accts. Payable",
        "Profit",
        "CONT.#",
        "Type",
        "Appt. Time",
        "Priority",
        "HAZ",
        "REF.#",
        "Chassis#",
        "LFD",
        "Origin",
        "ORI. Street",
        "ORI. City",
        "ORI. ST",
        "Destination",
        "DEST. Street",
        "DEST. City",
        "DEST. ST",
        "Dispatch",
        "Tasks",
      ];
      if (this.isLegacy) columns = columns.filter((o) => !excludes.includes(o));
      this.$actions.renameTableColumn("calltl", "Last Free Day", "LFD");
      this.$actions.renameTableColumn("calltl", "Term. LFD", "LFD");
      this.columnOptions.calltl = this.initTableColumns("calltl", columns);
    },
    resetColumns(target) {
      this.$actions.updateTableColumns({ [target]: [] });
      this.initColumnOptions();
    },
    disableColumns() {
      ["Accts. Payable", "Profit"].forEach((name) => {
        this.updateTableColumn("calimdl", name, {
          disabled:
            this.$store.envs.customer_mode || !this.$store.envs.access_payable,
        });
        this.updateTableColumn("calltl", name, {
          disabled:
            this.$store.envs.customer_mode || !this.$store.envs.access_payable,
        });
      });
      ["Accts. Receivable", "Profit"].forEach((name) => {
        this.updateTableColumn("calimdl", name, {
          disabled:
            this.$store.envs.driver_mode || !this.$store.envs.access_receivable,
        });
        this.updateTableColumn("calltl", name, {
          disabled:
            this.$store.envs.driver_mode || !this.$store.envs.access_receivable,
        });
      });
      ["Customers"].forEach((name) => {
        this.updateTableColumn("calimdl", name, {
          disabled: this.$store.envs.driver_mode,
        });
        this.updateTableColumn("calltl", name, {
          disabled: this.$store.envs.driver_mode,
        });
      });
      this.initColumnOptions();
    },
    toggleColumn(checked, target, name) {
      this.updateTableColumn(target, name, { visible: checked });
    },
    checkMove(event) {
      let name = event.draggedContext.element.name;
      return name != "ID" && event.draggedContext.futureIndex != 0;
    },
    moveColumn(target) {
      this.columnOptions[target].forEach((column, index) => {
        column.order = index + 1;
      });
      this.$actions.updateTableColumns({
        [target]: this.columnOptions[target],
      });
    },
    initByStorage() {
      this.$actions.renameSettings(
        "calendarHideCompletedOrders",
        "calendarCompletedOrdersHidden",
      );
      this.completedOrdersHidden = this.getSettings(
        "calendarCompletedOrdersHidden",
        false,
      );
      this.defaultColorStylesDisabled = this.getSettings(
        "calendarDefaultColorStylesDisabled",
        false,
      );
      this.opsDisplay = this.getSettings("calendarOpsDisplay", "default");
      this.taskDisplay = this.getSettings("calendarTaskDisplay", false);
      this.pickupInstrDisplay = this.getSettings(
        "calendarPickupInstrDisplay",
        false,
      );
      this.emptyReturnInstrDisplay = this.getSettings(
        "calendarEmptyReturnInstrDisplay",
        false,
      );
      this.orderDisplay = this.getSettings(
        "calendarOrderDisplay",
        "horizontal",
      );
    },
    formatDate(date) {
      return this.format(
        this.parse(date, "yyyy-MM-dd", new Date()),
        "EEE MM/dd",
      );
    },
    currentDay() {
      this.startEndDates = [this.today, this.today];
    },
    currentWeek() {
      const monday = this.startOfISOWeek(new Date());
      this.startEndDates = [
        this.format(monday, "yyyy-MM-dd"),
        this.format(this.addDays(monday, 6), "yyyy-MM-dd"),
      ];
    },
    previousDay() {
      const startDay = this.parse(
        this.startEndDates[0],
        "yyyy-MM-dd",
        new Date(),
      );
      const previous = this.addDays(startDay, -1);
      this.startEndDates = [
        this.format(previous, "yyyy-MM-dd"),
        this.startEndDates[1],
      ];
      this.activeTab = this.startEndDates[0];
    },
    nextDay() {
      const endDay = this.parse(
        this.startEndDates[1],
        "yyyy-MM-dd",
        new Date(),
      );
      const next = this.addDays(endDay, 1);
      this.startEndDates = [
        this.startEndDates[0],
        this.format(next, "yyyy-MM-dd"),
      ];
      this.activeTab = this.startEndDates[1];
    },
    previousWeek() {
      const startDay = this.parse(
        this.startEndDates[0],
        "yyyy-MM-dd",
        new Date(),
      );
      const monday = this.addDays(this.startOfISOWeek(startDay), -7);
      this.startEndDates = [
        this.format(monday, "yyyy-MM-dd"),
        this.format(this.addDays(monday, 6), "yyyy-MM-dd"),
      ];
    },
    nextWeek() {
      const startDay = this.parse(
        this.startEndDates[0],
        "yyyy-MM-dd",
        new Date(),
      );
      const monday = this.addDays(this.startOfISOWeek(startDay), 7);
      this.startEndDates = [
        this.format(monday, "yyyy-MM-dd"),
        this.format(this.addDays(monday, 6), "yyyy-MM-dd"),
      ];
    },
    removeTab(targetName) {
      const index = this.dateRanges.indexOf(targetName);
      if (index > 0) {
        let dates = [...this.dateRanges].slice(0, -1);
        this.startEndDates = [dates[0], dates[dates.length - 1]];
        this.activeTab = this.startEndDates[1];
      } else {
        let dates = [...this.dateRanges].slice(1);
        this.startEndDates = [dates[0], dates[dates.length - 1]];
        this.activeTab = this.startEndDates[0];
      }
    },
    updateCount({ mark, count }) {
      this.$set(this.counts, mark, count);
    },
    receive(data) {
      let hubIds = data.cross_hub_ids || [];
      hubIds.push(data.hub_id);
      if (!hubIds.includes(this.hubId)) return;
      if (data.legacy !== undefined && data.legacy != this.isLegacy) return;
      if (!this.agentScoped(data.agent_id)) return;
      this.receivedData = data;
    },
  },
};
</script>
<style lang="scss">
.container-calendar {
  @apply relative;

  .el-tabs.dense {
    @apply border-none #{!important};
  }
  .el-button--mini {
    @apply px-1.5 #{!important};
  }

  .btn-triggers {
    @apply absolute top-1 right-1 z-50 flex items-center gap-0.5 #{!important};

    .el-button {
      @apply text-base bg-white px-3 py-[1px] #{!important};
      & + .el-button {
        @apply m-0 #{!important};
      }
    }
  }

  .el-tabs--border-card.calendar {
    & > .el-tabs__header {
      @apply bg-slate-100 border-t mb-0 #{!important};

      .el-tabs__item {
        @apply text-gray-700 font-semibold #{!important};

        &:hover:not(.is-active) {
          @apply text-black bg-slate-200 #{!important};
        }

        &.is-active {
          @apply text-gray-800 font-bold #{!important};
        }
      }

      .el-tabs__nav-scroll {
        @apply w-4/5 #{!important};
      }

      .el-tabs__nav-next {
        @apply right-[15%] #{!important};
      }

      .el-tabs__nav-next,
      .el-tabs__nav-prev {
        @apply text-white #{!important};
      }

      #tab-previous,
      #tab-next {
        a {
          @apply text-sm;
        }
      }
    }
    .order-status-tab {
      @apply h-[calc(100vh_-_105px)] #{!important};
    }
  }

  .stripe {
    .stripe-item {
      @apply cursor-pointer;

      label {
        @apply box-border w-full mr-0 #{!important};
      }
    }
  }

  .draggable-columns {
    @apply max-h-96 overflow-y-auto overflow-x-hidden #{!important};
  }

  .sort-columns {
    @apply grid grid-cols-2 gap-1 min-w-0 #{!important};
    .box-content {
      @apply h-96 px-1 py-0.5 min-w-0 #{!important};
    }
  }
}

.report-stats {
  @apply -m-1 #{!important};

  #report-links {
    a {
      @apply block text-sm my-1 no-underline #{!important};
    }
  }
}
</style>
